<template>
  <div class="invite-wrap">
    <div class="main">
      <div class="first-page" v-if="onFirstPage">
        <div class="header">
          <div class="header-logo">
            <img
              v-if="!inviteInfo.banner"
              class="header-h5-logo"
              src="../../static/img/h5_logo.png"
              alt=""
            />
            <div v-if="!inviteInfo.banner" class="header-text">
              <p>熊猫签证</p>
              <p>足不出户办签证</p>
            </div>
            <img
              v-if="inviteInfo.banner"
              class="banner"
              :src="inviteInfo.banner"
              alt=""
            />
          </div>
          <div v-if="!inviteInfo.banner" class="service">
            <div class="service-item">
              <img src="../../static/img/h5_check.png" alt="" />
              <span>拒签退全款</span>
            </div>
            <div class="service-item">
              <img src="../../static/img/h5_check.png" alt="" />
              <span>免费拍签证照</span>
            </div>
            <div class="service-item">
              <img src="../../static/img/h5_check.png" alt="" />
              <span>自动填申请表</span>
            </div>
          </div>
          <div class="coupon-info">
            <div class="info-left">
              <span>{{ inviteInfo.discount_rate / 10 }}</span
              >&nbsp;折
            </div>
            <div class="info-right">
              <div class="type">
                <div class="info-company">{{ inviteInfo.company_name }}</div>
                <div class="info-tips">专享</div>
              </div>
              <div class="date">全场通用 无限次使用</div>
            </div>
          </div>
        </div>
        <div class="operate-area">
          <div class="input-area">
            <div
              class="input-group"
              @click="focusPhone()"
              :class="{
                'focused-box': phoneFocused,
                'unfocus-box': !phoneFocused,
              }"
            >
              <!-- <div class="country">+86</div> -->
              <input
                placeholder="输入手机号"
                type="tel"
                id="phone"
                maxlength="11"
                autocomplete="off"
                v-model="phoneNumber"
                ref="phone"
                @focus="phoneFocused = true"
                @blur="phoneFocused = false"
              />
            </div>
          </div>
          <div class="btn-area">
            <button
              class="btn"
              id="download"
              :disabled="loading || code === -1"
              @click="getCoupon()"
            >
              领取优惠券
            </button>
          </div>
        </div>

        <!-- <template v-if="inviteInfo.show_mode === 1">
          <div class="invite-code">
            <hr class="h-line">
            <div class="code" v-text="code"></div>
            <div class="info info2">
              <p>您也可以下载App后</p>
              <p>在“我的-优惠券”内兑换获得¥30优惠券</p>
            </div>
          </div>
          </template> -->
      </div>

      <div class="second-page" v-if="!onFirstPage">
        <div class="header"></div>
        <div class="st">
          恭喜！成功领取
          <span class="price"
            ><span>{{ inviteInfo.discount_rate / 10 }}折</span></span
          >
          优惠券
        </div>
        <div class="st">扫描二维码，下载App即可使用</div>
        <div class="vcode">
          <img src="../../static/img/vcode.png" width="200" />
        </div>
      </div>
    </div>

    <div class="footer">
      粤ICP备15048723号-2<br />
      Copyright© 熊猫签证 2016-2017，版权所有
    </div>

    <!-- <a class="fixed-footer"
      v-if="ua.qq || ua.wx"
      :class="{'focused-footer': phoneFocused, 'unfocus-footer': !phoneFocused}"
      href="http://api.11visa.com/oss/open/channel_stat?channel=rrqah2w2">
      <img src="../../static/img/download-left.png" class="left">
      <img src="../../static/img/download-right.png" class="right">
    </a> -->
    <!-- <template v-if="inviteInfo.show_mode === 1">
    <app-downLoad class="app" v-if="ua.qq || ua.wx" />
    </template> -->
  </div>
</template>

<script>
import '../lib/url.js';
import utils from '../services/tools.js';
import CouponService from '../services/couponService.js';
import toast from '../services/toast.js';
import env from '../services/dev.js';

export default {
  name: 'invite',
  data() {
    return {
      code: -1, // 企业优惠码
      inviteInfo: {}, // 邀请信息
      phoneNumber: '',
      ua: utils.getFullUA(),
      onFirstPage: true, // 第一页
      phoneFocused: false, // 输入框是否聚焦
      loading: false,
      couponService: new CouponService(this.$http),
    };
  },
  methods: {
    /**
     * 获取企业优惠码
     */
    getCode() {
      utils.init();
      if (!this.$route.query.code) {
        toast.show('缺少参数(优惠码)');
        return;
      }
      this.code = this.$route.query.code;
    },

    /**
     * 主动去给输入框聚焦
     */
    focusPhone() {
      this.$refs.phone.focus();
    },

    /**
     * 验证手机号
     */
    validatePhone() {
      this.haveError = !this.isPhoneValid();
    },

    /**
     * 手机号是否合法
     */
    isPhoneValid() {
      this.phoneNumber = this.phoneNumber.replace(/\D/g, '');

      return /^1\d{10}$/.test(this.phoneNumber);
    },

    /**
     * 领取优惠券
     */
    getCoupon() {
      MtaH5.clickStat('getcoupon_pany');
      if (!this.phoneNumber) {
        toast.show('请输入手机号！', 2000);
        return;
      }

      if (!this.isPhoneValid()) {
        this.focusPhone();
        toast.show('请输入正确的手机号！', 2000);
        return;
      }

      this.getInvite();
    },

    /**
     * 邀请
     */
    getInvite() {
      this.loading = true;
      this.couponService
        .couponGrab(this.phoneNumber, this.code)
        .then((data) => {
          const result = data.body;
          if (result.ret === 0) {
            toast.show('领取成功！');
            this.goH5(true);
          } else if (result.ret === -1) {
            toast.show(result.msg);
            this.goH5(false);
          } else if (result.ret === -2) {
            toast.show('尚未注册，手机验证码已发送');
            this.$router.push({
              name: 'register',
              params: {
                userId: -1,
                mobilePhone: this.phoneNumber,
              },
              query: {
                mobilePhone: this.phoneNumber,
                companyName: this.inviteInfo.company_name,
                type: 1,
                discount_rate: this.inviteInfo.discount_rate / 10,
                description: this.inviteInfo.description,
              },
            });
          } else {
            toast.show(result.msg);
          }
        })
        .catch(() => {
          toast.show('领取失败!');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 去下载页面
     */
    goH5(judgement) {
      if (utils.getPlatform() === 'pc') {
        if (judgement) {
          this.onFirstPage = false;
        }
      } else {
        setTimeout(() => {
          if (utils.isWxa()) {
            wx.miniProgram.switchTab({ url: '/pages/index/index' });
          } else {
            location.href = `https://${env}m.11visa.com/`;
          }
        }, 2000);
      }
    },

    /**
     * 获取邀请信息
     */
    getInviteInfo() {
      if (this.code < 0) return;

      this.couponService
        .queryCompanyCoupon(this.code)
        .then((data) => {
          const result = data.body;
          if (result.ret === 0) {
            this.inviteInfo = result.body;
            utils.setTitle(
              `熊猫签证给${this.inviteInfo.company_name}童鞋们送福利啦!`,
            );
          } else {
            toast.show(result.msg);
          }
        })
        .catch(() => toast.show('请求失败'));
    },
  },
  mounted() {
    this.getCode();
    this.getInviteInfo();
  },
  created() {
    MtaH5.clickStat('company_coupon');
    // 设置浏览器title
    utils.setTitle('熊猫签证送福利啦!');
  },
};
</script>

<style lang="less">
html {
  background-color: #f3f4f6;
}
</style>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

img {
  max-width: 100%;
}

.invite-wrap {
  background-color: white;
}

.main {
  margin-bottom: -1rem;

  &:after {
    content: '';
    display: block;
    height: 1rem;
  }
}

.header {
  background: url(../../static/img/header.png) no-repeat center bottom;
  background-size: cover;
  position: relative;
  height: 3.1rem;
  padding-top: 0.32rem;
  .header-logo {
    display: flex;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    font-size: 0px;
    .header-h5-logo {
      width: 0.45rem;
      height: 0.4rem;
    }
    .header-text {
      margin-left: 0.12rem;
      p:nth-of-type(1) {
        font-size: 0.16rem;
      }
      p:nth-of-type(2) {
        font-size: 0.12rem;
        margin-top: 0.08rem;
      }
    }
    .banner {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      z-index: 100;
    }
  }
  .service {
    display: flex;
    justify-content: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.12rem;
    margin-top: 0.25rem;
    img {
      width: 0.12rem;
      height: 0.12rem;
    }
    .service-item {
      display: flex;
      align-items: center;
      span {
        margin-left: 0.05rem;
      }
    }
    .service-item:nth-of-type(2) {
      padding: 0 0.28rem;
    }
  }
  .coupon-info {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 0.15rem;
    align-items: center;
    width: 64.533333%;
    left: 50%;
    transform: translateX(-50%);
    .info-left {
      width: 33%;
      flex-grow: 0;
      flex-shrink: 1;
      font-size: 0.16rem;
      color: #ff455a;
      display: flex;
      justify-content: center;
      align-items: baseline;
      span {
        font-size: 0.32rem;
      }
    }
    .info-right {
      flex-grow: 1;
      flex-shrink: 0;
      padding-right: 0.05rem;
      .type {
        color: #444444;
        font-size: 0.15rem;
        display: flex;
        .info-company {
          max-width: 1.2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: keep-all;
        }
        .info-tips {
          flex-shrink: 0;
        }
      }
      .date {
        margin-top: 0.1rem;
        font-size: 0.12rem;
        color: #aaaaaa;
      }
    }
  }
}

.operate-area {
  padding: 0 0.2rem;
  margin-top: 0.3rem;
}

.footer {
  height: 1.15rem;
  font-size: 0.12rem;
  text-align: center;
  line-height: 1.3;
  color: #cfcfcf;
  margin-top: 0.35rem;
  // position: absolute;
  // bottom: 0rem;
  // left: 50%;
  // transform: translateX(-50%);
  // width: 6.4rem;
}

.fixed-footer {
  padding: 0 0.11rem 0 0.18rem;
  height: 0.64rem;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(60, 60, 60, 0.8);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  display: block;
  margin-top: 0.1rem;

  .left {
    width: 1.335rem;
    margin-top: 0.11rem;
  }

  .right {
    float: right;
    width: 1.605rem;
    margin-top: 0.16rem;
  }
}

.invite-code {
  text-align: center;

  .h-line {
    border: none;
    // border-bottom: 1px dashed #e3e3e3;
    margin-top: 0.28rem;
    margin: 0.28rem 0.2rem 0 0.2rem;
  }

  .code {
    color: #333;
    font-size: 0.3rem;
    margin: 0.28rem auto 0.13rem auto;
    display: inline-block;
    padding-bottom: 0.1rem;
    border-bottom: 2px solid #333;
  }
}

.first-page {
}

.title {
  text-align: center;
  margin-top: 0.21rem;
  min-height: 0.16rem;
  font-size: 0.16rem;
}

.price {
  margin-top: 0.04rem;
  background: url(../../static/img/coupon-bg.png) no-repeat center center;
  background-size: 3.2rem 1rem;
  min-height: 1.3rem;

  .price-content {
    width: 2rem;
    height: 1.3rem;
    text-align: center;
    background: url(../../static/img/coupon-price.png) no-repeat center center;
    background-size: 100% 100%;
    margin: 0 auto;
    color: #ff5a60;
    position: relative;
  }

  .price-title {
    font-size: 0.12rem;
    padding-top: 0.28rem;
    font-weight: 600;

    span {
      transform: scale(0.6);
      display: inline-block;
      font-weight: 100;
      letter-spacing: 0.01rem;
    }
  }

  .money {
    font-size: 0.37rem;
    font-weight: 600;
    padding-top: 0.05rem;

    span {
      font-size: 0.16rem;
      position: relative;
      display: inline-block;
      top: -0.13rem;
    }
  }

  .hr {
    margin: 0.05rem auto 0 auto;
    border: none;
    border-top: 1px dashed #ff5a60;
    transform: scaleY(0.5);
    width: 1.6rem;
  }

  .price-bottom {
    color: #aaa;
    font-size: 0.12rem;
    padding-top: 0.05rem;
  }
}

.info {
  color: #777;
  font-size: 0.14rem;
  text-align: center;
  margin-top: 0.07rem;

  &:first-of-type {
    margin-top: 0.2rem;
  }
}

.info2 {
  color: #aaaaaa;
  p {
    font-size: 0.14rem;
    line-height: 0.22rem;
  }
}

.input-area {
  .input-group {
    border: 1px solid #ff5a60 !important;
    height: 0.45rem;
    font-size: 0;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 0.03rem;
    padding: 0 0.1rem;

    &.error {
      border-color: #f44336 !important;
    }

    input {
      -webkit-box-flex: 1;
      flex: 1;
      font-size: 0.14rem;
      border: none;
      outline: none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      display: inline;
      background: transparent;
      line-height: normal;
      &::placeholder {
        color: #aaaaaa;
      }
    }
  }

  .country {
    color: #aaa;
    font-size: 0.16rem;
  }

  .input-help {
    margin: 0.1rem auto 0 auto;
    font-size: 0.15rem;
    color: #f44336;
  }
}

.btn-area {
  margin-top: 0.15rem;

  .btn {
    font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
      FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
      Hiragino Sans GB W3, FontAwesome, sans-serif;
    display: block;
    width: 100%;
    background-image: linear-gradient(-20deg, #ff455a 0%, #ff6653 100%),
      linear-gradient(#ff5a60, #ff5a60);
    background-blend-mode: normal, normal;
    box-shadow: 0px 8px 20px 0px rgba(255, 90, 96, 0.3);
    border-radius: 8px;
    border: none;
    outline: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-appearance: none;
    height: 0.44rem;
    line-height: 0.44rem;
    text-align: center;
    font-size: 0.15rem;
    color: white;
    border-radius: 4px;

    &[disabled] {
      opacity: 0.3;
    }
  }
}

.second-page {
  text-align: center;

  .vcode {
    margin-top: 0.2rem;
  }

  .header {
    background: #ff5a60 url(../../static/img/invite/banner-pc.jpg) no-repeat
      center bottom;
    background-size: contain;
    position: relative;
    height: 140px;
    margin-bottom: 60px;
  }
}

#photo {
  margin-top: -1px;
}

.focused-box {
  border-color: #888 !important;
}

.unfocus-box {
  border-color: #ddd !important;
}

.focused-footer {
  position: relative;
}

.unfocus-footer {
  position: fixed;
}
</style>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .invite-wrap {
    width: 6.4rem;
    margin: 0 auto;
  }
  .main {
    margin-bottom: -1.4rem;
    &:after {
      height: 1.4rem;
      font-size: 0;
    }
  }
  .footer {
    height: 1.15rem;
    margin-top: 0;
    padding-top: 0.35rem;
  }
  .fixed-footer {
    display: none;
  }
  .invite-code {
    .code {
      font-size: 0.4rem;
      margin: 0.3rem auto 0.2rem auto;
      width: 2.4rem;
    }
  }
  .header {
    background-size: cover;
    height: 5rem;
    width: 640px;
    margin: 0 auto;
    img {
      max-height: 300px;
      display: block;
      width: auto;
    }
    .coupon-info {
      padding-bottom: 0.25rem;
      .info-left {
        font-size: 0.2rem;
        width: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: baseline;
        span {
          font-size: 0.6rem;
        }
      }
      .info-right {
        margin-left: 0;
        width: 2.63rem;
        .type {
          font-size: 0.23rem;
          .info-company {
            max-width: 1.8rem;
          }
        }
        .date {
          font-size: 0.15rem;
          margin-top: 0.2rem;
        }
      }
    }
    .header-logo {
      .banner {
        position: absolute;
      }
    }
  }
  .title {
    margin-top: 0.5rem;
    font-size: 0.28rem;
  }
  .price {
    margin-top: 0.2rem;
  }
  .price {
    .price-content {
      width: 3.7rem;
      height: 2rem;
      font-size: 0.38rem;
    }

    .price-title {
      padding-top: 0.45rem;
      font-size: 0.16rem;
    }

    .money {
      font-size: 0.56rem;
      padding-top: 0.1rem;

      span {
        font-size: 0.35rem;
      }
    }

    .hr {
      display: none;
    }

    .price-bottom {
      padding-top: 0.1rem;
    }
  }
  .info {
    font-size: 0.22rem;
    margin-top: 0.22rem;
  }
  .info:first-of-type {
    margin-top: 0.3rem;
  }
  .input-area {
    margin-top: 0.3rem;

    .input-group {
      width: 4.8rem;
      height: 0.6rem;
      margin: 0 auto;
      padding: 0 0.2rem;
      input {
        font-size: 0.22rem;
      }
    }

    .country {
      font-size: 0.22rem;
      line-height: 1px;
    }

    input {
      font-size: 0.22rem;
      margin-top: 1px;
    }

    .input-help {
      width: 4.8rem;
      font-size: 0.18rem;
    }
  }
  .btn-area {
    margin-top: 0.3rem;

    .btn {
      font-family: PingFang SC, Microsoft YaHei, Helvetica, Segoe UI,
        Lucida Grande, Helvetica, Arial, FreeSans, Arimo, Droid Sans,
        wenquanyi micro hei, Hiragino Sans GB, Hiragino Sans GB W3, FontAwesome,
        sans-serif;
      width: 4.8rem;
      margin: 0 auto;
      height: 0.6rem;
      line-height: 0.6rem;
      font-size: 0.22rem;
      border-radius: 6px;
    }
  }
  .second-page {
    // padding-top: 1.34rem;
    padding-top: 0;
    .st {
      font-size: 0.24rem;
      margin-bottom: 0.28rem;
      .price {
        color: #ff5a60;
        span {
          font-size: 0.48rem;
          font-weight: 700;
        }
      }
    }
    .vcode {
      margin-top: 0.4rem;
    }
  }
}
</style>
